import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import BigAdd from "./BigAdd";
import { Link } from "react-router-dom";
import SmallAdd from "./SmallAdd";
import ButtonTags from "./ButtonTags";
import { faLink } from "@fortawesome/free-solid-svg-icons";
// import SmartMobile from "./SmartMobile";
import { Circles } from "react-loader-spinner";
import SocialMediaShare from './SocialMediaShare';
import DOMPurify from 'dompurify'; // For sanitizing HTML content
import { faFacebook, faXTwitter, faWhatsapp, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from '@fortawesome/free-solid-svg-icons';
import InternationalDetails2 from "./InternationalDetails2";
import BollywoodNews2 from "./BollywoodNews2";
// import './style1.css';


const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
  }
  return text;
};

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};

const online = "https://api.shabdtoday.com/api/home/getAllDetails/"
const local = "https://localhost:44351/api/home/getAllDetails/"

function BusinessDetailsD() {
  const { mainKhabarId } = useParams();
  const [newsDetails, setNewsDetails] = useState(null);
    const [copySuccess, setCopySuccess] = useState(false);

  useEffect(() => {
    const fetchNewsDetails = async () => {
      try {
        const { data } = await axios.get(`${online}${mainKhabarId}`);
        console.log("Fetched data:", data);
        setNewsDetails(data);
      } catch (error) {
        console.error("Error fetching news details:", error);
      }
    };

    fetchNewsDetails();
  }, [mainKhabarId]);

  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी",
      "फरवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्टूबर",
      "नवंबर",
      "दिसंबर",
    ];
    const seconds = date.getSeconds();
    const minute = date.getMinutes();
    var hour = date.getHours();
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
  };

  const handleCopyLink = async () => {
    try {
      const url = "http://api.shabdtoday.com/Share/Page/" + mainKhabarId
      await navigator.clipboard.writeText(url);
      setCopySuccess(true);

      setTimeout(() => {
        setCopySuccess(false);
      }, 3000);
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  const getTimeAgoInHindi = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} सेकंड पहले`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} मिनट पहले`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} घंटे पहले`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
      return `${diffInDays} दिन पहले`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths} महीने पहले`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} साल पहले`;
  };
  const openPopup = (url) => {
    const width = 600, height = 500;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    window.open(url, "_blank",
      `width=${width},height=${height},top=${top},left=${left},status=no,toolbar=no,menubar=no,location=no`);
  };
  const generateShareLinks = (slug, heading) => {
    const encodedHeading = encodeURIComponent(heading);

    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        `https://api.shabdtoday.com/Share/Page2/${slug}`
      )}`,
      twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        `https://api.shabdtoday.com/Share/Page2/${slug}`
      )}&text=${encodedHeading}`,
      telegram: `https://t.me/share/url?url=${encodeURIComponent(
        `https://api.shabdtoday.com/Share/Page2/${slug}`
      )}&text=${encodedHeading}`
    };
  };

  if (!newsDetails) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {/* <Circles
          height="30"
          width="30"
          color="#f7265c"
          ariaLabel="circles-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        /> */}
      </div>
    );
  }

  const BASE_URL = "https://api.shabdtoday.com/";
  const image_resize = "https://api.shabdtoday.com/api/home/resize";
  const renderHtmlContent = (html) => {
    const sanitizedHtml = DOMPurify.sanitize(html);
    return { __html: sanitizedHtml };
  };
  return (
    <>
      {copySuccess && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#28a745",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "8px",
            fontSize: "16px",
            zIndex: 9999,
            boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
          }}
        >
          ✅ लिंक कॉपी हो गया है
        </div>
      )}
      <div>
        <div className="ak-post-wrapper" style={{ transform: "none" }}>
          <div
            className="ak-content-wrap ak-post-wrap ak-layout-style-1 clearfix ak-post-style-7 clearfix"
            style={{ transform: "none" }}
          >
            <div className="ak-container" style={{ transform: "none" }}>

              <div className="ak-content" style={{ transform: "none" }}>
                <div className="containercustome" style={{ transform: "none" }}>
                  <div className='mt-2'>
                    <BigAdd />
                  </div>
                  <div className="row grid-container" style={{ transform: "none" }}>
                    <div className="grid-item ak_column_1 col-md-3 sidebar-column sidebar-column-primary sticky-sidebar"
                      style={{
                        position: "relative",
                        overflow: "visible",
                        boxSizing: "border-box",
                        minHeight: 1
                      }}
                    >
                      <div
                        className="theiaStickySidebar"
                        style={{
                          paddingTop: 0,
                          paddingBottom: 1,
                          position: "sticky",
                          transform: "none",
                          top: 0,
                          left: "914.5px"
                        }}
                      >
                        <div className="sidebar post-sidebar">


                          <InternationalDetails2 />
                          {/* <FakeKhabre /> */}
                          <SocialMediaShare />


                        </div>
                        <div
                          className="resize-sensor"
                          style={{
                            position: "absolute",
                            inset: 0,
                            overflow: "hidden",
                            zIndex: -1,
                            visibility: "hidden"
                          }}
                        >
                          <div
                            className="resize-sensor-expand"
                            style={{
                              position: "absolute",
                              left: 0,
                              top: 0,
                              right: 0,
                              bottom: 0,
                              overflow: "hidden",
                              zIndex: -1,
                              visibility: "hidden"
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                left: 0,
                                top: 0,
                                transition: "all 0s ease 0s",
                                width: 410,
                                height: 1260
                              }}
                            />
                          </div>
                          <div
                            className="resize-sensor-shrink"
                            style={{
                              position: "absolute",
                              left: 0,
                              top: 0,
                              right: 0,
                              bottom: 0,
                              overflow: "hidden",
                              zIndex: -1,
                              visibility: "hidden"
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                left: 0,
                                top: 0,
                                transition: "0s",
                                width: "200%",
                                height: "200%"
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="grid-item ak_column_2 col-md-6">
                      <header className="entry-header ak-post-header mb-2">
                        <span style={{ fontWeight: 600, fontSize: "25px" }} dangerouslySetInnerHTML={renderHtmlContent(newsDetails.mainTazaKhabars.newsTag)}>
                        </span>
                      </header>
                      <div style={{ marginBottom: "2px" }}>
                        {newsDetails.mainTazaKhabars &&
                          stripHtmlTags(
                            newsDetails.mainTazaKhabars.editor
                          )}|
                        <span style={{ color: "grey" }}>{newsDetails.mainTazaKhabars &&
                          stripHtmlTags(
                            getTimeAgoInHindi(newsDetails.mainTazaKhabars.date)
                          )}</span>
                      </div>
                      <div className="ak-article-inner">
                        <div className="ak-article-inner">
                          <div className="ak-post-featured">
                            <div className="ak-featured-cover">
                              <Link href="wp-content/uploads/sites/26/2022/10/post-18.jpg" aria-label="whatsapp">
                                <div
                                  className="ak-featured-thumb  size-auto"
                                  style={{ paddingBottom: "70%" }}
                                >
                                  <img
                                    width={750}
                                    height={275}
                                    src={
                                      BASE_URL +
                                      newsDetails.mainTazaKhabars.newsImage
                                    }
                                    className="attachment-newsy_750x375 size-newsy_750x375 wp-post-image lazyautosizes lazyloaded"
                                    alt="taza Khabar"

                                    data-src={
                                      BASE_URL +
                                      newsDetails.mainTazaKhabars.newsImage
                                    }
                                    data-sizes="auto"
                                    data-srcset={

                                      BASE_URL +
                                      newsDetails.mainTazaKhabars.newsImage
                                    }
                                    data-expand={700}
                                    sizes="750px"
                                    srcSet={

                                      BASE_URL +
                                      newsDetails.mainTazaKhabars.newsImage
                                    }
                                  />
                                </div>
                              </Link>
                            </div>
                          </div>

                          <div
                            className="d-flex"
                            style={{
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                              padding: "0 10px",
                              flexWrap: "nowrap",
                              boxSizing: "border-box",
                            }}
                          >
                            {/* Left Section: View Count */}
                            <div style={{ display: "flex", alignItems: "center", gap: "2px", color: "grey", flexShrink: 0 }}>
                              <FontAwesomeIcon icon={faEye} style={{ fontSize: "14px" }} />
                              <span style={{ fontSize: "14px" }}>
                                {newsDetails?.mainTazaKhabars?.viewCount ?? 0}
                              </span>
                            </div>

                            {/* Right Section: Social Share Icons */}
                            <div style={{ display: "flex", alignItems: "center", gap: "12px", flexShrink: 0 }}>
                              <Link
                                to={`/News-Details/${newsDetails.slug}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  const slug = newsDetails?.mainTazaKhabars?.slug;
                                  const newsTag = newsDetails?.mainTazaKhabars?.newsTag;
                                  openPopup(generateShareLinks(slug, newsTag).facebook);
                                }}
                                aria-label="Share on Facebook"
                              >
                                <FontAwesomeIcon icon={faFacebook} style={{ color: "#1877F2", fontSize: "24px" }} />
                              </Link>


                              <Link
                                to={`/News-Details/${newsDetails.slug}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  openPopup(generateShareLinks(newsDetails?.mainTazaKhabars?.mainKhabarId, newsDetails?.mainTazaKhabars?.newsHeading).twitter);
                                }}
                                aria-label="Share on Telegram"
                              >
                                <FontAwesomeIcon icon={faXTwitter} style={{ color: "#0088cc", fontSize: "24px" }} />
                              </Link>

                              {/* <Link
                                to={generateShareLinks(newsDetails?.mainTazaKhabars?.mainKhabarId, newsDetails?.mainTazaKhabars?.newsHeading).facebook}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Share on Facebook"
                              >
                                <FontAwesomeIcon icon={faFacebook} style={{ color: "#1877F2", fontSize: "24px" }} />
                              </Link>
                              <Link
                                to={generateShareLinks(newsDetails?.mainTazaKhabars?.mainKhabarId, newsDetails?.mainTazaKhabars?.newsHeading).twitter}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Share on Twitter"
                              >
                                <FontAwesomeIcon icon={faXTwitter} style={{ color: "#1DA1F2", fontSize: "24px" }} />
                              </Link> */}
                              {/* <Link
                                to="#"
                                onClick={() => handleWhatsAppShare(mainKhabarId)}
                                aria-label="Share on WhatsApp"
                              >
                                <FontAwesomeIcon
                                  icon={faWhatsapp}
                                  style={{ color: "#25D366", fontSize: "24px", cursor: "pointer" }}
                                />
                              </Link> */}

                              <Link
                                to={`/News-Details/${newsDetails.slug}`}
                                onClick={handleCopyLink}
                                aria-label="Copy share link"
                              >
                                <FontAwesomeIcon
                                  icon={faLink}
                                  style={{ color: "#28a745", fontSize: "24px", cursor: "pointer" }}
                                />
                              </Link>
                            </div>
                          </div>

                          <br></br>
                          <div className="ak-post-content">
                            <span
                              dangerouslySetInnerHTML={renderHtmlContent(newsDetails.mainTazaKhabars.newsDetails)}
                            ></span>
                          </div>
                          <ButtonTags />
                        </div>
                      </div>
                    </div>
                    <div
                      className="grid-item ak_column_1 col-md-3 sidebar-column sidebar-column-primary-right sticky-sidebar"
                      style={{
                        position: "relative",
                        overflow: "visible",
                        boxSizing: "border-box",
                        minHeight: 1
                      }}
                    >
                      <div
                        className="stickybar"
                        style={{
                          paddingTop: 0,
                          paddingBottom: 1,
                          position: "sticky",
                          transform: "none",
                          top: 0,
                          left: "914.5px"
                        }}
                      >
                        <div className="sidebar post-sidebar">
                          <BollywoodNews2 />
                          <SmallAdd />

                          {/* <TajaKhabar2 /> */}
                          {/* <TajaKhabar5 /> */}
                          {/* <SmallAdd /> */}
                          {/* <div className='mt-2'>
                          <TajaKhabar4 />
                        </div> */}


                        </div>
                        <div
                          className="resize-sensor"
                          style={{
                            position: "absolute",
                            inset: 0,
                            overflow: "hidden",
                            zIndex: -1,
                            visibility: "hidden"
                          }}
                        >
                          <div
                            className="resize-sensor-expand"
                            style={{
                              position: "absolute",
                              left: 0,
                              top: 0,
                              right: 0,
                              bottom: 0,
                              overflow: "hidden",
                              zIndex: -1,
                              visibility: "hidden"
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                left: 0,
                                top: 0,
                                transition: "all 0s ease 0s",
                                width: 410,
                                height: 1260
                              }}
                            />
                          </div>
                          <div
                            className="resize-sensor-shrink"
                            style={{
                              position: "absolute",
                              left: 0,
                              top: 0,
                              right: 0,
                              bottom: 0,
                              overflow: "hidden",
                              zIndex: -1,
                              visibility: "hidden"
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                left: 0,
                                top: 0,
                                transition: "0s",
                                width: "200%",
                                height: "200%"
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  )
}

export default BusinessDetailsD;
